module.exports = __webpack_public_path__ + "assets/img/page-title-63dbd38f.png";